// Mock data for JPS Metal & Alloys website

// import stainlessSteelTubes from "/assests/stainless-steel-tubes.webp";
// import stainlessSteelSheetsPlates from "/assests/Stainless-Steel-Sheets-Plates.jpg";
// import ssRods from "/assests/ss-rods.jpg";
// import stainlessSteelFlanges from "/assests/stainless-steel-flanges.jpg";
// import nickelAlloys from "/assests/nickel-alloys.jpg";
// import duplex from "/assests/duplex.jpg";
// import specialAlloys from "/assests/alloy steel tound bar.jpg";
// import forging from "/assests/forging.jpg";
// import finishedShafts from "/assests/finished shafts.jpg";
// import backdrop from "/assests/backdrop.jpg";

export const companyInfo = {
  name: "JPS Metal & Alloys",
  tagline: "Crafting Excellence through Quality",
  description:
    "Leading supplier and stockist of premium stainless steel and high-performance alloys across India for over four decades.",
  phone: "+91 9930143255",
  email: "vedaant@jpsmetal.in",
  whatsapp: "https://wa.link/5qtkrm",
  heroBackground: "/assests/backdrop.jpg",
  // "https://images.unsplash.com/photo-1698560475244-d55af7c69aec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxzdGFpbmxlc3MlMjBzdGVlbCUyMHJvdW5kJTIwYmFyc3xlbnwwfHx8fDE3NTYwMTQ3NDV8MA&ixlib=rb-4.1.0&q=60&w=1920",
  address: {
    line1: "301, 3rd floor, A WING, KRISHVI ESCAPE,",
    line2: "NEAR VINAY HEALTH HOME,",
    line3: "FANASWADI BHULESHWAR,",
    city: "MUMBAI – 400002",
    country: "INDIA",
  },
  certifications: ["ISO 9001:2015", "NACE Approved", "Third Party Inspection"],
  experience: "40+ Years",
  established: "1984",
};

export const heroStats = [
  { number: "40+", label: "Years of Experience" },
  { number: "5000+", label: "Products in Stock" },
  { number: "500+", label: "Happy Clients" },
  { number: "15+", label: "Industries Served" },
];

export const products = [
  {
    id: 1,
    name: "Stainless Steel Pipes & Tubes",
    description:
      "Comprehensive range of seamless and welded stainless steel pipes in various grades and sizes.",
    grades: ["304", "304L", "316", "316L", "321", "347"],
    applications: ["Oil & Gas", "Chemical Processing", "Food Industry"],
    slug: "stainless-steel-pipes-tubes",
    image: "/assests/stainless-steel-tubes.webp",
  },
  {
    id: 2,
    name: "Stainless Steel Sheets & Plates",
    description:
      "Premium quality sheets and plates with superior surface finish and dimensional accuracy.",
    grades: ["316", "316L", "304", "304L", "410", "420", "409"],
    applications: ["Architecture", "Kitchen Equipment", "Industrial"],
    slug: "stainless-steel-sheets-plates",
    image: "/assests/Stainless-Steel-Sheets-Plates.jpg",
  },
  {
    id: 3,
    name: "Round Bars & Rods",
    description:
      "High-precision round bars and rods for machining and fabrication applications.",
    grades: ["316", "316L", "304", "304L", "410", "420", "416", "17-4PH"],
    applications: ["Automotive", "Aerospace", "Marine"],
    slug: "round-bars-rods",
    image: "/assests/ss-rods.jpg",
  },
  {
    id: 4,
    name: "Flanges & Fittings",
    description:
      "Complete range of flanges and pipe fittings meeting international standards.",
    grades: ["316", "316L", "304", "304L", "2205", "32760", "32750"],
    applications: ["Petrochemical", "Power Plants", "Refineries"],
    slug: "flanges-fittings",
    image: "/assests/stainless-steel-flanges.jpg",
  },
  {
    id: 5,
    name: "Nickel Alloys",
    description:
      "Specialized nickel alloys for high-temperature and corrosive environments.",
    grades: [
      "Inconel 625",
      "Inconel 718",
      "Hastelloy C276",
      "Monel 500",
      "Monel 400",
      "904L",
      "Alloy 20",
    ],
    applications: ["Aerospace", "Chemical Processing", "Marine"],
    slug: "nickel-alloys",
    image: "/assests/nickel-alloys.jpg",
  },
  {
    id: 6,
    name: "Duplex & Super Duplex",
    description:
      "Advanced duplex stainless steels combining strength and corrosion resistance.",
    grades: ["2205", "2507", "S32750", "S32760"],
    applications: ["Oil & Gas", "Desalination", "Chemical"],
    slug: "duplex-super-duplex",
    image: "/assests/duplex.jpg",
  },
  {
    id: 7,
    name: "Special Alloys",
    description:
      "Custom alloys designed for specific industrial applications and extreme conditions.",
    grades: ["Titanium", "Tungsten", "Beryllium Copper", "Phosphor Bronze"],
    applications: ["Electronics", "Defense", "Medical"],
    slug: "special-alloys",
    image: "/assests/specail alloys.jpg",
  },
  {
    id: 8,
    name: "Forged Components",
    description:
      "Precision forged components with exceptional mechanical properties.",
    grades: [
      "316L",
      "Super Duplex",
      "Inconel 625",
      "Inconel 718",
      "Hastelloy C276",
      "Monel 400",
      "Titanium Grade 2",
      "Duplex 2205",
      "304L",
      "321",
      "347",
      "17-4PH",
      "15-5PH",
    ],
    applications: ["Heavy Engineering", "Power Generation", "Mining"],
    slug: "forged-components",
    image: "/assests/forging.jpg",
  },
  {
    id: 9,
    name: "Alloy Steel Round Bars",
    description:
      "High-strength alloy steel round bars engineered for demanding applications requiring superior mechanical properties and toughness.",
    grades: ["EN8(C45)", "EN19(4140)", "EN24", "4130", "34CrNiMo6"],
    applications: [
      "Automotive Components",
      "Machinery Manufacturing",
      "Tool Making",
    ],
    slug: "alloy-steel-round-bars",
    image: "/assests/alloy steel tound bar.jpg", // ✅ fixed: using local image instead of slug mistake
  },
  {
    id: 10,
    name: "Finished Shafts",
    description:
      "We specialize in manufacturing precision-engineered finished shafts according to customer drawings and specifications, delivering components ready for immediate use.",
    grades: ["As per requirements"],
    applications: [
      "Custom Engineering",
      "Machinery Assembly",
      "Equipment Manufacturing",
    ],
    slug: "finished-shafts",
    image: "/assests/finished shafts.jpg",
  },
];
export const services = [
  {
    icon: "Wrench",
    title: "Custom Cutting",
    description:
      "Precision cutting services to your exact specifications using advanced machinery.",
  },
  {
    icon: "TestTube",
    title: "Material Testing",
    description:
      "Comprehensive material testing including ultrasonic testing (UT) and chemical analysis.",
  },
  {
    icon: "Flame",
    title: "Heat Treatment",
    description:
      "Professional heat treatment services to enhance material properties and performance.",
  },
  {
    icon: "FileCheck",
    title: "Quality Certification",
    description:
      "Complete documentation and certification with manufacturer test certificates (MTC).",
  },
  {
    icon: "Truck",
    title: "Quick Delivery",
    description:
      "Reliable and timely delivery across India with ready stock availability.",
  },
  {
    icon: "Headphones",
    title: "Technical Support",
    description:
      "Expert technical consultation and application-specific material recommendations.",
  },
];

export const industries = [
  {
    name: "Oil & Gas",
    description:
      "High-performance alloys for upstream, midstream, and downstream operations.",
    icon: "Fuel",
  },
  {
    name: "Chemical Processing",
    description:
      "Corrosion-resistant materials for harsh chemical environments.",
    icon: "Beaker",
  },
  {
    name: "Power Generation",
    description:
      "Specialized alloys for thermal, nuclear, and renewable energy applications.",
    icon: "Zap",
  },
  {
    name: "Aerospace",
    description:
      "Lightweight, high-strength materials for aircraft and spacecraft applications.",
    icon: "Plane",
  },
  {
    name: "Automotive",
    description:
      "Precision materials for automotive components and manufacturing.",
    icon: "Car",
  },
  {
    name: "Marine",
    description:
      "Seawater-resistant alloys for shipbuilding and offshore applications.",
    icon: "Anchor",
  },
  {
    name: "Food & Pharmaceutical",
    description:
      "Hygienic-grade materials meeting FDA and pharmaceutical standards.",
    icon: "Shield",
  },
  {
    name: "Infrastructure",
    description:
      "Structural materials for bridges, buildings, and construction projects.",
    icon: "Building",
  },
];

export const qualityFeatures = [
  {
    title: "ISO 9001:2015 Certified",
    description:
      "Internationally recognized quality management system certification.",
    icon: "Certificate",
  },
  {
    title: "Third Party Inspection",
    description:
      "Independent quality verification by accredited testing agencies.",
    icon: "TestTube",
  },
  {
    title: "Manufacturer Test Certificates",
    description: "Complete traceability with original mill test certificates.",
    icon: "FileCheck",
  },
  {
    title: "In-House Testing",
    description:
      "Advanced testing facilities for chemical and mechanical properties.",
    icon: "TestTube",
  },
  {
    title: "Quality Assurance",
    description: "Rigorous quality control at every stage of the supply chain.",
    icon: "Shield",
  },
  {
    title: "Customer Support",
    description: "Dedicated technical support and after-sales service team.",
    icon: "HeartHandshake",
  },
];

export const partners = [
  "Viraj Profiles Limited",
  "Ambica Steels Limited",
  "Laxcon Steels Private Limited",
  "Jindal Stainless Limited",
  "Outokumpu Stainless",
  "Sandvik Materials Technology",
];

// SEO-optimized content for technical pages
export const seoContent = {
  stainlessSteel: {
    title: "Stainless Steel Supplier Mumbai | Premium SS Grades",
    metaDescription:
      "Leading stainless steel supplier in Mumbai offering 304, 316, 321 grades. ISO certified with ready stock of pipes, sheets, bars. Quick delivery across India.",
    content:
      "JPS Metal & Alloys is Mumbai's trusted stainless steel supplier with over 40 years of experience. We stock premium grades including 304, 304L, 316, 316L, 321, and 347 in various forms - pipes, tubes, sheets, plates, round bars, and fittings.",
  },
  nickelAlloys: {
    title: "Nickel Alloys Stockist Mumbai | Inconel, Hastelloy Supplier",
    metaDescription:
      "Premium nickel alloys supplier in Mumbai. Stock Inconel 625, 718, Hastelloy C-276, Monel 400. ISO certified with MTC. Quick delivery across India.",
    content:
      "Specialized supplier of high-performance nickel alloys including Inconel, Hastelloy, and Monel grades. Perfect for aerospace, chemical processing, and high-temperature applications.",
  },
};
